import './ConsentModal.scss';

import React, {useState, useEffect} from 'react';

import {
  AAMBeaconButton,
  AAMBeaconModal
} from 'components/shared/Beacon';
import { Spinner } from "@trp-beacon-ui-kit/react-communication";
import { usePrevious } from 'support/ReactUtils';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';
import { connect } from 'react-redux';

const ConsentModal = ({ onCancel, onSave, termsContent, showConsentModal, requestStatus, hideConsentActionZone, webViewEnabled }) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const previousRequestStatus = usePrevious(requestStatus && requestStatus.updateDocumentDelivery);

  useEffect(() => {
    if(previousRequestStatus === REQUEST_STATES.requested && requestStatus.updateDocumentDelivery && requestStatus.updateDocumentDelivery === REQUEST_STATES.received) {
      setShowSpinner(false);
      handleModalCancel();
    }

    if(previousRequestStatus === REQUEST_STATES.requested && requestStatus.updateDocumentDelivery && requestStatus.updateDocumentDelivery === REQUEST_STATES.error) {
      setShowSpinner(false);
      handleModalCancel();
    }
  }, [requestStatus])

  const closeModal = () => {
    const modal = document.getElementById('paperless-preferences-terms-modal');
    if (modal) {
      modal.close();
    }
  }

  const handleModalCancel = () => {
    closeModal();
    onCancel();
  };

  const handleModalSave = () => {
    setShowSpinner(true);
    onSave();
  }

  return showConsentModal ? (
    <AAMBeaconModal
      className="paperless-preferences-consent-modal"
      open={true}
      size="normal"
      id="paperless-preferences-terms-modal"
      closeOnClickOut={false}
      onBeaconEventClose={() => onCancel()}>
      {
        //Recommendation from Beacon to add tab index to make longer content scrollable
        <div dangerouslySetInnerHTML={{ __html: termsContent }} />
      }
      {!hideConsentActionZone &&
        <div slot="action-zone" className="b-flex b-justify-between">
          <AAMBeaconButton
            onBeaconEventClick={() => handleModalCancel()}
            variant="tertiary"
            scale="jumbo"
          >
            Cancel
          </AAMBeaconButton>
          {showSpinner &&
          <div className="loading-spinner">
            <Spinner />
          </div>
          }
          {!showSpinner &&
          <AAMBeaconButton
            variant="primary"
            onBeaconEventClick={() => handleModalSave()}
            disabled={webViewEnabled}
            scale="jumbo"
          >
            Submit
          </AAMBeaconButton>
          }
        </div>
      }
    </AAMBeaconModal>
  )
    : null;
}

const mapStateToProps = (state) => ({
  webViewEnabled: getCustomerWebView(state)
});

export default connect(mapStateToProps)(ConsentModal);